import styles from "./Onboarding.module.css"
import OnboardingForm from "../../Onboarding/OnboardingForm";
import { handleBackgroundScroll } from "../../../utils/backgroundScroll";
import { useEffect } from "react";
import { log } from "../../../utils/logger";
/**
* Props for the OnboardingPopup component.
*/ 
interface OnboardingProps{
    onClose?: ()=>void, // Close popup handler
    display?: boolean, // Whether to display
    className?:string, // Optional additional class
    cardClassName?:string // Optional additional card class
}
/**
* A onboarding popup component.
* Contains onboarding form
*
* @param props OnboardingProps
* @param {() => void} props.onClose - Close popup handler
* @param {boolean} props.display - Whether to display
* @param {string} props.className - Optional additional class
* @param {string} props.cardClassName - Optional additional card class
* @returns TSX.Element
*/
const OnboardingPopup = ({onClose,  cardClassName, display = false, className}:OnboardingProps) => {
    // Stop scroll on open
    useEffect(()=>{
        handleBackgroundScroll(display)
    }, [display])
    return(
        <>
        {display && (
            <div className={`${display ? styles.Popup : styles.PopupHidden} ${className || ''}`}>
                <div className={styles.PopupBg} onClick={onClose}></div>
                <div className={`${styles.PopupCard} ${cardClassName || ''}`}>
                    <OnboardingForm className={styles.OnboardingForm} onBack={onClose} popup={true}/>
                </div>
            </div>
        )}
        </>
    )
};

export default OnboardingPopup;